import { useEffect, useRef, useState } from "react";
import Icon from "components/Elements/Icon/Icon";
import ExpiresAfterDropdown from "./ExpiresAfterDropdown";
import useOnClickOutside from "hooks/useOnClickOutside";
import { ButtonAccessability } from "components/Elements/Button/Button";
import { useUploader } from "contexts/uploaderContext/uploaderContext";
import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "contexts/userContext/userContext";

import styles from "./expireDaysCounter.module.scss";
import Tooltip from "components/Elements/Tooltip/Tooltip";

const ExpireDaysCounter = ({ isSettingItem }: { isSettingItem?: boolean }) => {
  const { getSaved, setSaved, setExpireAfter, getExpireAfter } = useUploader();
  const { getUserData, isSubscribed } = useUser();
  const { getTextByKey, getHtmlByKey } = useContent();
  const [show, setShow] = useState(false);

  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    setShow(false);
  });

  useEffect(() => {
    if (getExpireAfter()) return;
    if (getUserData()?.AutoRemoveDays) {
      setExpireAfter(getUserData().AutoRemoveDays);
      return;
    } else {
      if (isSubscribed()) {
        setExpireAfter(7);
      } else {
        setExpireAfter(3);
      }
    }
  }, [getUserData().AutoRemoveDays, isSubscribed()]);

  return getSaved() ? (
    <ButtonAccessability
      onClick={() => {
        setSaved(false);
      }}
      className={styles.saved}
    >
      {/* @ts-ignore */}
      <Tooltip tooltipText={getHtmlByKey("save-mail-tooltip")}>
        <Icon name="saved" />
        {getTextByKey("saved-mail-uploader")}
      </Tooltip>
    </ButtonAccessability>
  ) : (
    <ButtonAccessability
      className={`${styles.counter} ${isSettingItem ? styles.settingItem : ""}`}
      onClick={() => setShow((prev) => !prev)}
      elemRef={ref}
    >
      {getExpireAfter() + " " + getTextByKey("days")}{" "}
      <Icon name="arrow-down" gray iconClass={styles.arrow} />
      <ExpiresAfterDropdown showState={show} currentValue={getExpireAfter()} />
    </ButtonAccessability>
  );
};

export default ExpireDaysCounter;
